<su-headline h="h1" skin="primary">{{
  'edit_site.label__title' | translate
}}</su-headline>

<su-headline h="h2" skin="tertiary" *ngIf="siteAddress">
  {{ siteAddress.streetName }}, {{ siteAddress.postalCode }}
  {{ siteAddress.city }}
</su-headline>

<div [style]="descriptionContainerStyle" *ngIf="frozenStatus">
  <div
    class="sub-headline contactDescription"
    [style]="descriptionStyle"
    [innerHtml]="description | safeHtml"></div>
</div>

<su-card [card]="adaptedCardFields">
  <div card-content>
    <formly-form [form]="form" [fields]="formFields" [model]="formModel">
    </formly-form>
  </div>
</su-card>

<div *ngIf="hasActiveUsages === true" style="width: 850px">
  <mtx-grid
    #grid
    [columns]="columns"
    [data]="data"
    [loading]="isLoadingData"
    [rowStriped]="true"
    [noResultText]="'grid.no_results' | translate"
    [rowHover]="true"
    [cellSelectable]="false"
    [showColumnMenuButton]="false"
    (rowClick)="onRowClick($event)">
  </mtx-grid>
</div>

<app-spinner-overlay
  [show]="isLoading"
  [label]="loadingMessage"></app-spinner-overlay>
